import * as __au2ViewDef from './app.html';
import { customElement } from '@aurelia/runtime-html';
@customElement(__au2ViewDef)
export class App {
    righty = "oh my"
}
